import { json } from 'd3';
import React, { useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next'
import configData from '../../../temp/config';
import './origin-drop-down.css';

let filterList = [];
let isClearAll = false;
const OriginFlter = (props) => {

    const [counter, setCounter] = useState(props.counter || 0)
    const [showItems, setShowItems] = useState(false)
    const [defaultSearchType, setDefaultSearchType] = useState(props.filters[1].fields.placeholderLabel.value);
    // originItem : getting it from layout response to show options in Gender filter dropdown
    const [originItem, setOriginItem] = useState(props.filters[1].fields.filterItems);
    // originFilterList : list of all selected filter 
    const [originFilterList, setOriginFilterList] = useState(JSON.parse(sessionStorage.getItem('originFilterList')) || [])
    const { t } = props;

    useEffect(() => {
        // document.addEventListener('click', closeGenderFilterDropDown);
        // setOriginFilterList(originFilterList);
        // props.getOriginFilterData(originFilterList)
    }, [])

    useEffect(() => {
        setOriginItem(originItem)
        setOriginFilterList(originFilterList);
    }, [counter])

    const dropDown = () => {
        if (props.searchString.length === 0) setShowItems(false)
        else setShowItems(!showItems)
        // if(originFilterList.length > 0) setShowItems(true)
    }

    const closeDropDown = () => {
        setShowItems(false)
        // Setting filterList here to be show in selected filter bar
        // setOriginFilterList(filterList);
        // props.getOriginFilterData(filterList)
    }

    const closeGenderFilterDropDown = (event) => {
        console.log(event.target.className)
        if (event.target.className === 'select-box--selected-item-origin' && document.getElementsByClassName('select-box--arrow-down')[0] !== undefined) {
            setShowItems(true)
        }
        else if (event.target.className === 'select-box--arrow-down') {
            setShowItems(false)
        }
        else if (event.target.className === 'select-box--arrow-up') {
            setShowItems(true)
        } else if (event.target.className === 'btn btn-clear' || event.target.className === "custom-checkbox") {
            setShowItems(true)
        }
        else {
            setShowItems(false)
        }

    }

    // In this method dynamically updating 'originItem' based on the selection of particular checkbox
    const selectItem = (item) => {
        // Creating an Array that contains the checked/selected options
        // initially filterList is kept blank
        let checkItem = [] // this is a temp variable to check already present item in filterList array

        if (filterList.length === 0) {
            //if filterList is blank then simply push whatever is selected
            filterList.push(item)
        } else {
            // if filterList is not blank, then we are cheking if that element is already 
            // present or not means same item can be de-selected after selection
            checkItem = filterList.filter(f_item => {
                if (f_item.id === item.id) {
                    return f_item
                }
            })
            // checkItem.length === 0 means that element is not found, means its a new element
            // we need to push the element in filterList Array
            if (checkItem.length === 0) {
                filterList.push(item);
            }
            // if length is not 0 then means its not a new element was selected earlier
            // now user has deselected that, so we need to remove that
            else if (checkItem.length > 0) {
                // we are iterating over the filterList and having a check where selected element id is not equal to items
                checkItem = filterList.filter(f_item => {
                    if (f_item.id !== item.id) {
                        return f_item
                    }
                })
                // So now we are having only selected element
                filterList = checkItem
                // we had simply assign it to filterList : we will update the actual filterlist once user clicks on 'Done' button
            }
            // console.log(checkItem)
        }
        // console.log('creating filter list while cheking checkbozes',filterList);
        // Setting filterList here to be show in selected filter bar
        setOriginFilterList(filterList);
        sessionStorage.setItem('originFilterList', JSON.stringify(filterList))
        props.getOriginFilterData(filterList)
        // console.log(originItem)

        // After having the selected filterlist, we need to update the 'originItem' dynamically
        originItem.map((gitem) => {
            if (gitem.id === item.id) {
                gitem.fields.selectbyDefault.value = !gitem.fields.selectbyDefault.value
            }
            return gitem;
        })
        // Dynamically updating selected/unselected states of options
        setOriginItem(originItem)
        // counter is being updated for component to be reloaded
        setCounter(counter + 1)
    }

    const clearAll = () => {
        isClearAll = true
        originItem.map((gitem) => {
            // if(gitem.id === item.id){
            gitem.fields.selectbyDefault.value = false
            // }
            return gitem;
        })
        filterList = [];
        setOriginFilterList([]);
        setOriginItem(originItem)
        setCounter(counter + 1)
        props.getOriginFilterData([])
        sessionStorage.setItem('originFilterList', JSON.stringify([]))
    }

    const removeItem = (item) => {
        // console.log(item)
        originItem.map((gitem) => {
            if (gitem.id === item.id) {
                gitem.fields.selectbyDefault.value = false
                return gitem
            } else {
                return gitem
            }
        })
        let tempFilterList = filterList.filter((fitem) => {
            if (fitem.id !== item.id) {
                return fitem
            }
        })
        filterList = tempFilterList;
        setOriginFilterList(tempFilterList);
        props.getOriginFilterData(tempFilterList)
        sessionStorage.setItem('originFilterList', JSON.stringify(tempFilterList))
        setOriginItem(originItem)
        setCounter(counter + 1)

        // console.log('originItem at time of removing item',originItem)

    }

    return (
        <>
            <div className="nameSearchFilterDropdown">
                <div className="custom-select-dropdown">

                    <div className="select-box--box">
                        <div className="select-box--container"  >
                            <div className={originFilterList.length > 0 ? "select-box--selected-item-origin border-highlighted" : 'select-box--selected-item-origin'} onClick={dropDown}>
                                {defaultSearchType}
                            </div>
                            <div className="select-box--arrow" name="select-box--name" onBlur={closeDropDown}>
                                <span name="drop-down-arrow" className={`${showItems ? 'select-box--arrow-up fa fa-angle-up' : 'select-box--arrow-down fa fa-angle-down'}`}>
                                </span>
                            </div>
                            <div style={{ display: showItems ? 'block' : 'none' }}
                                className="select-box--items"
                            >

                                {
                                    originItem.map((item, index) => {
                                        return (
                                            <div
                                                key={index}
                                                onClick={() => selectItem(item)}
                                                className={defaultSearchType === item.fields.name.value ? 'selected' : ''}
                                            >
                                                <input type="checkbox" checked={item.fields.selectbyDefault.value} readOnly className="custom-checkbox" /><p className="nameListItem">
                                                    {item.fields.name.value}
                                                </p>
                                            </div>
                                        )
                                    })
                                }
                                <div className="button-container" >
                                    <button onClick={clearAll} className="btn btn-clear" disabled={originFilterList.length === 0}>Clear All</button>
                                    <button onClick={closeDropDown} className="btn btn-primary" disabled={originFilterList.length === 0}>Done</button>

                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </div>
            <div className="babyfilterValueConatiner">
                {originFilterList.length > 0 && originFilterList.map((item, index) => {
                    return (
                        <div key={index} className="filterValueWrapper" onClick={() => removeItem(item)}>
                            <p className="filterValueText">{item.fields.name.value}</p>
                            <i className="fa fa-times"></i>

                        </div>
                    )
                })}
            </div>

        </>
    )
};

export default withTranslation()(OriginFlter);